import Validation from "@irati/utils/validation"

export const getTeamSchema = (required?: boolean = null) => {
  return Validation.string(required && "admin.helpers.getTeamSchema.validation.string")
    .min(3, "admin.helpers.getTeamSchema.validation.min")
    .max(50, "admin.helpers.getTeamSchema.validation.max")
    .matches(/^\S.*\S$/, "admin.helpers.getTeamSchema.validation.noStartEndSpaces")
}

/* eslint-disable quotes */
export const universalCodeSchema = () => {
  return Validation.string("admin.helpers.universalCodeSchema.validation.required")
    .min(8, "admin.helpers.universalCodeSchema.validation.min")
    .max(55, "admin.helpers.codeSchema.validation.max")
    .matches(/[a-z]/, "admin.helpers.universalCodeSchema.validation.lowercase")
    .matches(/[A-Z]/, "admin.helpers.universalCodeSchema.validation.uppercase")
    .matches(/[0-9]/, "admin.helpers.universalCodeSchema.validation.number")
    .matches(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~£\\]/, "admin.helpers.universalCodeSchema.validation.specialCharacter")
}

export const codeSchema = (required: boolean = true) => {
  return Validation.string(required ? "admin.helpers.codeSchema.validation.string" : null)
    .min(5, "admin.helpers.codeSchema.validation.min")
    .max(55, "admin.helpers.codeSchema.validation.max")
    .matches(/^[^<>"' ]+$/, "admin.helpers.codeSchema.validation.matches")
}
/* eslint-enable quotes */

export const mobileSchema = () => {
  /* eslint-disable */
  return Validation.string().test("validPhoneNumberOrEmpty", "account.profile.fields.phone.validation.matches", (value: string) => {
    if (!value) {
      return true
    }

    return !!value.match(/^[+]?([\d]{0,3})?[\(\.\-\s]?(([\d]{1,3})[\)\.\-\s]*)?(([\d]{3,5})[\.\-\s]?([\d]{4})|([\d]{2}[\.\-\s]?){4})$/)
  })
  /* eslint-enable */
}

export const firstnameSchema = () => {
  return Validation.string("account.profile.fields.firstname.validation.string")
    .max(50)
    .test("notJustSpaces", "account.profile.fields.firstname.validation.test", (value) => value && value.trim().length !== 0)
}

export const lastnameSchema = () => {
  return Validation.string().min(2, "account.profile.fields.lastname.validation").max(50)
}

export const emailSchema = () => {
  return Validation.string("account.profile.fields.email.validation.required")
    .max(255)
    .email("account.profile.fields.email.validation.email")
}
